import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useMemo } from 'react';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { LinkBox, LinkOverlay } from '@hub/link';
import { forwardRef } from '@hub/design-system-base';
import { Imposter } from '@hub/imposter';
import { Badge } from '@hub/badge';
import { ClickAndCollectMediumIcon } from '@hub/icon';
import PotentialLink from '@scentregroup/shared/hub-components/potential-link';
import { generateStoreFrontUrl } from '@scentregroup/shared/helpers/store';
import { CloudinaryImage } from '../cloudinary-image';
import { getProductListingIssue } from '../../helpers/stock-level-issue-messages';
import { AnalyticsListContext } from '../analytics/analytics-list-context';
import makeUniqueProductId from '../../helpers/make-unique-product-id';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductCard = forwardRef(({
  badgeText,
  imageRef,
  sx,
  product,
  onClick
}, ref) => {
  var _shop$retailer;

  const {
    title,
    price,
    discountedPrice,
    percentDiscount,
    shop,
    brand,
    callToAction,
    image,
    issues,
    sku,
    objectID
  } = product;
  const issue = useMemo(() => getProductListingIssue(issues), [issues]);
  const priceToDisplay = discountedPrice || price;
  const analyticsList = useContext(AnalyticsListContext);
  return /*#__PURE__*/_jsx(LinkBox, {
    ref: ref,
    sx: sx,
    as: props => {
      var _product$brand, _product$shop$retaile, _product$shop$retaile2, _product$category, _product$category2, _analyticsList$list, _analyticsList$positi, _analyticsList$positi2;

      return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
        'data-ecomm-product': 'product',
        'data-product-brand': (_product$brand = product.brand) !== null && _product$brand !== void 0 ? _product$brand : '',
        'data-product-retailer': product.shop.name,
        'data-product-retailer-id': (_product$shop$retaile = (_product$shop$retaile2 = product.shop.retailer) === null || _product$shop$retaile2 === void 0 ? void 0 : _product$shop$retaile2.sys.id) !== null && _product$shop$retaile !== void 0 ? _product$shop$retaile : '',
        'data-product-category': (_product$category = (_product$category2 = product.category) === null || _product$category2 === void 0 ? void 0 : _product$category2[product.category.length - 1]) !== null && _product$category !== void 0 ? _product$category : '',
        'data-product-id': product.variantGroupCode,
        'data-product-unique-id': makeUniqueProductId(product.variantGroupCode, product.shop.id, sku),
        'data-product-name': product.title,
        'data-product-price': priceToDisplay,
        'data-product-list': (_analyticsList$list = analyticsList === null || analyticsList === void 0 ? void 0 : analyticsList.list) !== null && _analyticsList$list !== void 0 ? _analyticsList$list : 'unknown collection deck',
        'data-product-variant': '',
        'data-product-variant-sku': sku,
        'data-product-currency': 'AUD',
        'data-product-position': (_analyticsList$positi = analyticsList === null || analyticsList === void 0 ? void 0 : analyticsList.positions[product.sku]) !== null && _analyticsList$positi !== void 0 ? _analyticsList$positi : '',
        'data-insights-object-id': objectID,
        'data-insights-position': (_analyticsList$positi2 = analyticsList === null || analyticsList === void 0 ? void 0 : analyticsList.positions[product.sku]) !== null && _analyticsList$positi2 !== void 0 ? _analyticsList$positi2 : ''
      }));
    },
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(Stack, {
      gap: "spacing-sm",
      children: [/*#__PURE__*/_jsx(Imposter, {
        impose: badgeText ? /*#__PURE__*/_jsx(Badge, {
          icon: props => /*#__PURE__*/_jsx(ClickAndCollectMediumIcon, _objectSpread({}, props)),
          children: badgeText
        }) : undefined,
        position: "bottom-left",
        margin: "spacing-xs",
        children: /*#__PURE__*/_jsx(CloudinaryImage, {
          imageSetOrImage: {
            url: image.url,
            alt: image.alt || title,
            type: 'WIDE'
          },
          resizeMode: "pad",
          imageRef: imageRef,
          ratio: "2/3",
          sx: {
            '& > img': {
              outline: '1px solid rgb(217,218,221, 0.7)',
              outlineOffset: '-1px'
            }
          }
        })
      }), /*#__PURE__*/_jsxs(Stack, {
        gap: "spacing-xs",
        children: [/*#__PURE__*/_jsx(Text, {
          fontSize: "font-sm",
          children: brand
        }), /*#__PURE__*/_jsx(LinkOverlay, {
          href: callToAction.url,
          children: /*#__PURE__*/_jsx(Text, {
            fontSize: "font-sm",
            children: title
          })
        }), !issue && /*#__PURE__*/_jsx(Text, {
          fontSize: "font-md",
          tone: "strong",
          children: priceToDisplay
        }), shop.name && /*#__PURE__*/_jsxs(Text, {
          fontSize: "font-sm",
          color: "quartz",
          sx: {
            marginTop: 'spacing-xs'
          },
          children: ["Sold by\xA0", /*#__PURE__*/_jsx(PotentialLink, {
            href: generateStoreFrontUrl((_shop$retailer = shop.retailer) === null || _shop$retailer === void 0 ? void 0 : _shop$retailer.sys.id),
            children: shop.name
          })]
        }), issue && /*#__PURE__*/_jsx(Text, {
          color: "error",
          fontSize: "font-sm",
          sx: {
            marginTop: 'spacing-sm'
          },
          children: issue.message
        }), discountedPrice && !issue && /*#__PURE__*/_jsxs(Stack, {
          sx: {
            marginTop: 'spacing-sm'
          },
          children: [/*#__PURE__*/_jsx(Text, {
            fontSize: "font-sm",
            color: "quartz",
            sx: {
              textDecoration: 'line-through'
            },
            children: price
          }), /*#__PURE__*/_jsx(Text, {
            fontSize: "font-md",
            tone: "strong",
            color: "brand",
            children: percentDiscount
          })]
        })]
      })]
    })
  });
});